import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PageWrapper } from '../components/PageWrapper';

// Render AI text with bold framework words
const renderAIText = (text) => {
  if (!text) return null;
  const parts = text.split(/(\*\*[A-Z]+\*\*)/g);
  return parts.map((part, i) => {
    const match = part.match(/^\*\*([A-Z]+)\*\*$/);
    if (match) return <strong key={i} className="font-bold">{match[1]}</strong>;
    return <span key={i}>{part}</span>;
  });
};

export const AIResponse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { response, userName, returnTo } = location.state || {};

  const handleContinue = () => {
    if (returnTo) {
      navigate(returnTo);
    } else {
      navigate('/');
    }
  };

  return (
    <PageWrapper className="bg-app">
      <div className="min-h-screen flex flex-col items-center justify-center px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="max-w-sm w-full text-center"
        >
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="font-body text-sm text-primary leading-relaxed mb-16"
            data-testid="ai-response-text"
          >
            {renderAIText(response) || `Well done, ${userName || 'friend'}. You showed up today.`}
          </motion.p>

          <motion.button
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.4 }}
            onClick={handleContinue}
            className="bg-theme-primary text-theme-dark rounded-full px-12 py-4 font-body font-medium transition-all hover:opacity-90 hover:-translate-y-0.5 shadow-sm"
            style={{
              backgroundColor: 'var(--theme-primary, #D4C7EB)',
              color: 'var(--theme-dark, #2D2D35)',
            }}
            data-testid="continue-btn"
          >
            Continue
          </motion.button>
        </motion.div>
      </div>
    </PageWrapper>
  );
};

export default AIResponse;
